<div class="formgrid grid acordion-container-card">
    <div class="col-12 md:col-12">
        <p-accordion>
            <p-accordionTab [selected]="true" header="Datos de los antecedentes" class="line-height-3 m-0">
                <div *ngIf="registro">
                    <p-table 
                        [value]="getFormDataArray()" 
                        [paginator]="false" 
                        responsiveLayout="stack" 
                        styleClass="p-datatable-gridlines" 
                        [tableStyle]="{'min-width': '50rem'}">
                        
                        <ng-template pTemplate="body" let-item>
                            <tr>
                                <td class="td-title-table-r-profesional">{{ getLabel(item.key) }}</td>
                                <td>{{ getFormattedValue(item.value) }}</td>
                                <div class="flex justify-content-end mt-3">
                                    <button pButton icon="pi pi-calendar"
                                    *ngIf="item.key==='fechaVencimientoPermiso' && !this.ls.isRolCliente()"
                                        [label]="'Editar Fecha de Vencimiento del Permiso'"
                                        class="p-button"
                                        [pTooltip]="'Edita las fechas de permiso y vencimiento'"
                                        (click)="abrirDialogoFechas()">
                                    </button>
                                </div>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>
<p-dialog header="Actualizar fechas de antecedentes"
    *ngIf="!this.ls.isRolCliente()"
    [(visible)]="mostrarDialogo"
    (onHide)="cancelarDialogo()"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '40vw' }"
    [draggable]="false"
    [baseZIndex]="10000">

  <!-- Fecha de Otorgamiento -->
  <div class="field flex gap-2 align-items-center justify-content-center">
    <label for="fechaOtorgamiento">Fecha de otorgamiento del permiso</label>
    <p-calendar
      [(ngModel)]="fechaOtorgamiento"
      [showIcon]="true"
      [dateFormat]="'yy-mm-dd'"
      inputId="fechaOtorgamiento"
      [appendTo]="'body'">
    </p-calendar>
  </div>

  <!-- Fecha de Vencimiento -->
  <div class="field mt-3 flex gap-2 align-items-center justify-content-center">
    <label for="fechaVencimiento">Fecha de vencimiento del permiso</label>
    <p-calendar
      [(ngModel)]="fechaVencimiento"
      [showIcon]="true"
      [dateFormat]="'yy-mm-dd'"
      inputId="fechaVencimiento"
      [appendTo]="'body'">
    </p-calendar>
  </div>
    <div class="flex justify-content-end mt-3">
        <button pButton label="Guardar"
            (click)="guardarFecha()"
            [disabled]="!fechaOtorgamiento && !fechaVencimiento">
        </button>
    </div>
</p-dialog>